import React from 'react';
import { Container, Box } from '@mantine/core';

import Packages from '../components/Packages';

export default function OrderHistoryPage() {
  return (
    <Container size="lg" my="xl">
      <div className="mb-40">
        <Packages />
      </div>
    </Container>
  );
};

